const getPaymentAdjustmentTitle = (canExchange, isPayable) => {
  if (!canExchange) {
    return I18n.t('ibe.payment.total_payment_due');
  }

  if (isPayable) {
    return I18n.t('ibe.payment.exchange.payable');
  }

  return I18n.t('ibe.payment.exchange.refund');
};

export default getPaymentAdjustmentTitle;
